import { Field } from 'redux-form';
import SelectField from '../../../../../shared/form-elements/select/field';
import Input from '../../../../../shared/form-elements/input';
import Checkbox from '../../../../../shared/form-elements/checkbox';
import { formatMoney } from '../../../../../shared/format';
import React from 'react';
import Calendar from '../../../../../shared/calendar/main';

const Form = props => (
	<div className="payouts-form__main-fields">
		<div className="affiliates display-flex width-100-p flex-column">
			<div className="flex-center">
				<div className="ui-form__element width-50-p padding-0-5-0-0">
					<Field
						name="affiliate"
						placeholder={props.intl('Affiliate')}
						component={Input}
						multi={false}
						disabled={true}
					/>
				</div>
				<div className="ui-form__element width-50-p padding-0-5-0-0">
					<Calendar
						{...props.affiliateTransactionCalendar}
						onInit={props.affiliateTransactionCalendarInit}
						onToggle={props.affiliateTransactionCalendarToggle}
						onChange={data => {
							props.affiliateTransactionCalendarChange(data);
						}}
						onApply={props.affiliateTransactionCalendarApply}
						intl={props.intl}
					/>
				</div>
			</div>
			<div className="affiliates display-flex width-100-p">
				<div className="ui-form__element amount width-50-p padding-0-5-0-0">
					<Field
						onChange={() => {}}
						name="amount"
						placeholder={props.intl('Amount')}
						normalize={value => formatMoney(value, true)}
						component={Input}
					/>
				</div>
				<div className="ui-form__element currencies width-50-p">
					<Field
						name="currency"
						placeholder={props.intl('Currency')}
						component={SelectField}
						searchable={false}
						multi={false}
						onChange={currency => props.changeTransactionCurrency(currency[0].value)}
						options={props.selectOptions['currencies']}
					/>
				</div>
			</div>
			<div className="affiliates display-flex width-100-p">
				<div className="ui-form__element amount width-50-p padding-0-5-0-0">
					<Field
						onChange={() => {}}
						multi={true}
						searchable={true}
						name="offer_ids"
						placeholder={props.intl('Offer')}
						component={SelectField}
						options={props.offersOfTransactionLookup}
					/>
				</div>
				<div className="ui-form__element currencies width-50-p">
					<Field
						name="country_ids"
						placeholder={props.intl('Country')}
						component={SelectField}
						searchable={true}
						multi={true}
						options={props.countriesLookup}
					/>
				</div>
			</div>
			<div className="display-flex flex-center">
				<div className="ui-form__element currencies width-50-p">
					<Field
						name="conversion_ids"
						placeholder={props.intl('Conversion_ids separated by comma (optional)')}
						component={Input}
					/>
				</div>
				<div className="ui-form__element currencies width-50-p padding-0-15">
					<Field
						name="is_not_only_approved"
						placeholder={props.intl('Include conversions with any status?')}
						component={Checkbox}
					/>
				</div>
			</div>
			<div className="ui-form__element comment">
				<Field name="comment" placeholder={props.intl('Comment')} component={Input} />
			</div>
		</div>
	</div>
);

export default Form;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payouts/components/forms/transaction/forms-parts/transferMoney.js